// @ts-nocheck
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { getText } from "../../../../utils/util";
import copy from "copy-to-clipboard";
import { Cell, Dialog } from "react-vant";
import "./tailwind.css";
import { Button } from "antd";
import { Toast } from "antd-mobile";
import { useState } from "react";
import { imageConfig } from "../../../../config/config";

export default function CenterPage({
  coinList,
  userInfo,
  qbSum,
  setVisible,
  setVisibleTK,
  setVisibleTK2,
  setVisibleCK,
  isShowZF,
  loading,
}) {
  const navigate = useNavigate();
  const { t: translate } = useTranslation();
  const lan = localStorage.getItem("i18n");
  const c2ctxStatus = localStorage.getItem("c2ctxStatus");
  const companySkin = localStorage.getItem("companySkin");

  const getNode = () => {
    const nodes = [];
    for (let i = 0; i < coinList.length; i++) {
      const data = coinList[i];
      const node = (
        <div
          key={data?.id}
          className="w-full bg-neutral-800/80 rounded-xl shadow-lg mb-4 transition-all duration-300 hover:bg-neutral-700/90 record-item-enter"
          style={{animationDelay: `${i * 0.05}s`}}
          onClick={() => {
            navigate(`/extract/${data?.id}`);
          }}
        >
          <div className="p-4">
            <div className="flex justify-between items-center">
              <div className="flex items-center space-x-4">
                <div className="relative w-10 h-10 flex-shrink-0">
                  <img
                    src={imageConfig.baseImageUrl + data?.img}
                    className="w-full h-full rounded-full object-cover border border-primary/30"
                    alt={data.name}
                  />
                  <div className="absolute -bottom-1 -right-1 w-4 h-4 bg-primary rounded-full flex items-center justify-center">
                    <span className="text-white text-[10px] font-bold">✓</span>
                  </div>
                </div>
                <div className="flex flex-col">
                  <span className="text-white font-medium">{`${data.name.toUpperCase()}${
                    data.czline ? `(${data.czline})`.toUpperCase() : ""
                  }`}
                  {lan == "zh" && translate(getText("提現"))}
                  {lan != "zh" && <span className="ml-1">{translate(getText("提現"))}</span>}
                  </span>
                  <span className="text-xs text-neutral-400">
                    {/* {translate(getText("推荐提现通道"))} */}
                  </span>
                </div>
              </div>
              <div className="flex items-center">
                <span className="text-primary-light text-sm mr-1">
                  {translate(getText("提現"))}
                </span>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-primary-light" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </div>
            </div>
          </div>
        </div>
      );
      nodes.push(node);
    }
    return nodes;
  };
  
  if (loading) {
    return (
      <div className="flex justify-center items-center py-16">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
      </div>
    );
  }
  
  return (
    <div className="p-6 revert-style">
      <div className="mb-6">
        <div className="bg-warning/20 border-l-4 border-warning p-4 rounded-r-xl">
          <p className="text-neutral-300 text-sm leading-relaxed">
            {translate(
              getText(
                "注意：提現操作不可撤銷，請仔細確認您的提現金額和賬戶信息，謹防詐騙。"
              )
            )}
          </p>
        </div>
      </div>
      <h2 className="text-white text-xl font-bold mb-6 flex items-center">
        <div className="w-1 h-6 bg-primary rounded-full mr-2"></div>
        {translate(getText("請選擇以下提現通道"))}
      </h2>
      
      <div className="space-y-4 animate-slide-up">
        {getNode()}
        {c2ctxStatus == 1 && (
          <div
            className="w-full bg-neutral-800/80 rounded-xl shadow-lg mb-4 transition-all duration-300 hover:bg-neutral-700/90 record-item-enter"
            style={{animationDelay: `${coinList.length * 0.05}s`}}
            onClick={() => {
              if (c2ctxStatus == 1) {
                setVisibleTK(true);
              }
            }}
          >
            <div className="p-4">
              <div className="flex justify-between items-center">
                <div className="flex items-center space-x-4">
                  <div className="relative w-10 h-10 flex-shrink-0">
                    <img
                      src="/level/20240216074328978161.png"
                      className="w-full h-full rounded-full object-cover border border-primary/30"
                      alt="C2C提現"
                    />
                    <div className="absolute -bottom-1 -right-1 w-4 h-4 bg-primary rounded-full flex items-center justify-center">
                      <span className="text-white text-[10px] font-bold">✓</span>
                    </div>
                  </div>
                  <div className="flex flex-col">
                    <span className="text-white font-medium">
                      {translate(getText("C2C提現"))}
                    </span>
                    <span className="text-xs text-neutral-400">
                      {/* {translate(getText("推荐提现通道"))} */}
                    </span>
                  </div>
                </div>
                <div className="flex items-center">
                  <span className="text-primary-light text-sm mr-1">
                    {translate(getText("提現"))}
                  </span>
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-primary-light" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
